<template>
  <div class="jobList">
    <div class="o-main-content-area">
        <div class="table_header_wrapper sticky_header" style="top: 70px">
            <div class="row with-adjust-on-open-sidenav">
                <div class="col-md-12 o-no-padding c-responsive-fixwidth">
                    <div class="col-md-3">
                        <h1 class="h1 route-heading1">Jobs / Events</h1>
                    </div>
                    <div class="col-md-9 text-right">
                        <ul class="o-filter-area">
                            <li v-if="getPower('jobEvent')&&(getJobFiltersPower()||userRoleSlug=='power-user'||isSteward||isDispatcher)" class="o-search-placeholder-fix">
                                <div class="input-group stylish-input-group">
                                    <input type="text" v-on:keyup="updateValue" v-model="searchBox" tabindex="4" id="assign-emp-search" class="form-control table_search" placeholder="Job#, Event, Employer, Venue">
                                    <span class="input-group-addon">
                                        <button type="submit">
                                            <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                        </button>
                                    </span>
                                </div>
                            </li>
                            <li v-if="getAddJobPower()">
                                <a href="javascript: void(0)" @click="addJobModal()" class="c-solid-btn c-solid-btn--green">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    Add New Job
                                </a>
                            </li>
                            <li v-if="getPower('silentDelete')" style="display: flex; align-items: center; margin-left: 10px;">
                                <span style="font-size: 12px; color: #333; margin-right: 5px;">Auto-Fill:</span>
                                <el-switch
                                    v-model="afMasterEnabled"
                                    @change="onChangeAfMaster"
                                    active-color="#f57c00"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0">
                                </el-switch>
                            </li>
                            <li v-if="getPower('jobEvent')&&getJobFiltersPower()"><a href="javascript: void(0)" class="c-filter-link" @click="filterLink()"><i class="fa fa-filter" aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row with-adjust-on-open-sidenav mt-10 mb-5">
                <div class="col-md-12 c-responsive-fixwidth o-tab-area">
                    <div class="col-md-6 o-no-padding">
                        <ul class="o-tab-view o-tab-view--text js-job-tab-select">
                            <li v-if="myJobDisplay"><a href="javascript: void(0)" @click="changeTab('Myjob', 'day', false)" :class="(preSelectedTab.parent == 'Myjob')?'active':'custom-deactive-btn'">My Jobs</a></li>
                            <li v-if="getPower('allJob')"><a href="javascript: void(0)" @click="changeTab('Alljob', 'day', false)" :class="(preSelectedTab.parent == 'Alljob')?'active':'custom-deactive-btn'">All Jobs</a></li>
                            <li>Show Deleted Jobs:</li>
                            <li class="o-accordion-element">
                                <el-switch
                                    style="display: block"
                                    v-model="deleted_jobs"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value=1
                                    :inactive-value=0
                                    @change="changeDeletedJobSwitch"
                                >
                                </el-switch>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="c-common-space with-adjust-on-open-sidenav">
                <div class="c-responsive-fixwidth">
                    <div class="col-md-7 col-sm-7 o-no-padding">
                        <ul class="o-tab-view o-month-tab" id="filter-buttons-row">
                            <li :class="(preSelectedTab.child == 'day')?'o-month-select':''"><a href="javascript: void(0)" @click="changeTab(preSelectedTab.parent, 'day', false)" class="c-common-btn">Next 45 Days</a></li>
                            <li :class="(preSelectedTab.child == 'incomplete')?'o-month-select':''"><a href="javascript: void(0)" @click="changeTab(preSelectedTab.parent, 'incomplete', false)" class="c-common-btn">Incomplete</a></li>

                            <li :class="(preSelectedTab.child == 'today')?'o-month-select':''"><a href="javascript: void(0)" @click="changeTab(preSelectedTab.parent, 'today', false)" class="c-common-btn">Today</a></li>

                            <li :class="(preSelectedTab.child == 'tomorrow')?'o-month-select':''"><a href="javascript: void(0)" @click="changeTab(preSelectedTab.parent, 'tomorrow', false)" class="c-common-btn">Tomorrow</a></li>

                            <li @click="getPrev()">
                                <i class="fa fa-arrow-circle-left btn-arraw-adjust" aria-hidden="true"></i>
                            </li>
                            <li :class="(preSelectedTab.child == 'month')?'o-month-select':''">
                                <div class="block o-datepicker-input">
                                    <el-date-picker
                                    v-model="monthSort"
                                    type="month"
                                    @change="changeTab(preSelectedTab.parent, 'month', false)"
                                        format="MMM"
                                    placeholder="Month">
                                    </el-date-picker>
                                </div>
                            </li>
                            <li @click="getNext()">
                                <i class="fa fa-arrow-circle-right btn-arraw-adjust" aria-hidden="true"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-5 col-sm-5 o-job-sort-btn-position">
                        <ul class="o-tab-view o-month-tab" v-if="getPower('jobEvent')&&getJobFiltersPower()">
                            <li>
                                <h1 class="sort-by-label">Sort By:</h1>
                            </li>
                            <li :class="{'o-month-select':sortType == 'employer'}"><a @click="sortBy('employer')" href="javascript: void(0)" class="c-common-btn">Employer</a></li>
                            <li :class="{'o-month-select':sortType == 'steward'}"><a @click="sortBy('steward')" href="javascript: void(0)" class="c-common-btn">Steward</a></li>
                            <li :class="{'o-month-select':sortType == 'venue'}" class="padding-right-md"><a @click="sortBy('venue')" href="javascript: void(0)" class="c-common-btn">Venue</a></li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="jobList && jobList.length <= 0 && afterAPI == true" class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3" style="margin-top: 165px;">
            <div class="col-md-12 no-job-dispaly">
                <br />
                {{isSteward ? 'No Steward Assignments' : isDispatcher ? 'No Dispatcher Assignments' : 'No Data Stored'}}
            </div>
        </div>

        <div v-else class="c-common-space c-responsive-fixwidth" style="margin-top: 160px;">
            <div
                v-if="domReady"
                v-loading="loading"
                class="c-common-space-inner"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;"
            >
                <div class="col-md-12 o-no-padding">
                    <div class="panel-group" id="accordion">                       
                        <div class="panel panel-default o-accordion-area c-common-box-shadow" v-for="(job,key) in jobList" :key="key">
                            <div class="panel-heading o-accordion-heading new-o-accordion-heading c-common-gradient">
                                <div @click="jobDetails(job)" class="col-md-3 o-no-padding" :class="{'o-disabled-deleted-job': job.deleted_at}">
                                    <div class="new-o-accordion-title">
                                        <router-link :to="{ name: 'jobDetails', params: { id:changeJobIdMorph(job.id)}}" class="new-admin-event-head" :class="getJobBackgroundClass(job)"> Event:
                                        <span>{{job.title}}
                                            <el-tooltip v-if="isLoginSuper" class="item" effect="dark" content="Click to Copy Job Data" placement="top-start">
                                                <a @click.stop="copyText(job)" class="o-job-copy-icon"><i class="fa fa-paste"></i></a>
                                            </el-tooltip>
                                        </span>
                                        <span>
                                            <el-tooltip v-if="isLoginSuper" class="item" effect="dark" content="Download Pdf Archive" placement="top-start">
                                            <a @click.stop="copyText(job)" class="o-job-copy-icon"><i class="fa fa-download"></i></a>
                                            </el-tooltip>
                                        </span>
                                        <br/>
                                        <span>- {{(job.employee && job.employee.employable) ? job.employee.employable.first_name+" "+job.employee.employable.last_name : "-"}}</span> <span class="ml-10"> {{ " - " + job.job_number }} </span>
                                        </router-link>
                                    </div>
                                </div>
                                <div @click="jobDetails(job)" class="col-md-2 o-no-padding" :class="{'o-disabled-deleted-job': job.deleted_at}">
                                    <div class="new-o-accordion-title">
                                        <router-link :to="{ name: 'jobDetails', params: { id:changeJobIdMorph(job.id)}}" class="margin-bottom-2px employer-header-font-min new-admin-event-head" :class="getJobBackgroundClass(job)">
                                            <span>@ {{(job.venue)?job.venue.name:"-"}}</span>
                                        </router-link>
                                        <router-link :to="{ name: 'jobDetails', params: { id:changeJobIdMorph(job.id)}}" class="employer-header-font-min new-admin-event-head" :class="getJobBackgroundClass(job)">
                                            <span>
                                                for {{(job.employer)?job.employer.name:"-"}}
                                                <span>
                                                    {{ displayEmployerContact(job) }}
                                                </span>
                                            </span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-7 text-right new-left-right-padding">
                                    <ul class="o-job-accordio-header">
                                        <li class="joblist-dateField">
                                            <div class="o-accordion-element">
                                                {{ getUserDateFormat(job.start)+' to '+getUserDateFormat(job.end)}}
                                            </div>
                                        </li>
                                        <li :class="{'o-disabled-deleted-job': job.deleted_at}">
                                            <span class="o-accordion-head">Pub</span>
                                            <div class="o-accordion-element">
                                                <el-switch
                                                style="display: block"
                                                v-model="job.status.name"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                active-value="Published"
                                                inactive-value="Draft"
                                                @change="publishedJob(job)"
                                                :disabled="!getPower('silentDelete')"
                                                >
                                                </el-switch>
                                            </div>
                                        </li>
                                        <li v-if="afMasterEnabled" :class="{'o-disabled-deleted-job': job.deleted_at}">
                                            <span class="o-accordion-head" style="color: #f57c00;">AF</span>
                                            <div class="o-accordion-element">
                                                <el-switch
                                                style="display: block"
                                                v-model="job.af_onoff"
                                                active-color="#f57c00"
                                                inactive-color="#dcdfe6"
                                                :active-value="1"
                                                :inactive-value="0"
                                                @change="toggleJobAf(job)"
                                                :disabled="!getPower('silentDelete')"
                                                >
                                                </el-switch>
                                            </div>
                                        </li>
                                        <li>
                                            <span class="o-accordion-head">Report:</span>
                                            <div class="o-accordion-element o-table-checklist">
                                                <i v-if="job.report && job.report.length>0" class="fa fa-check-circle" aria-hidden="true"></i>
                                                <i v-if="job.report && job.report.length==0" class="fa fa-times-circle" aria-hidden="true"></i>
                                            </div>
                                            <span class="o-accordion-head">HW:</span>
                                            <div class="o-accordion-element o-table-checklist">
                                                <i v-if="job.hw && job.hw.length>0" class="fa fa-check-circle" aria-hidden="true"></i>
                                                <i v-if="job.hw && job.hw.length==0" class="fa fa-times-circle" aria-hidden="true"></i>
                                            </div>
                                            <span class="o-accordion-head">Other:</span>
                                            <div class="o-accordion-element o-table-checklist">
                                                <i v-if="job.other && job.other.length>0" class="fa fa-check-circle" aria-hidden="true"></i>
                                                <i v-if="job.other && job.other.length==0" class="fa fa-times-circle" aria-hidden="true"></i>
                                            </div>
                                            <span class="o-accordion-head">HTS:</span>
                                            <div class="o-accordion-element o-table-checklist">
                                                <i v-if="job.hts_flag" class="fa fa-check-circle" aria-hidden="true"></i>
                                                <i v-if="!job.hts_flag" class="fa fa-times-circle" aria-hidden="true"></i>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="o-accordion-element">
                                                <span class="o-issue-counter" :class="getJobIndicatorBackgroundClass(job)">
                                                {{(job && job.unassigned_calls_count!=0)?job.unassigned_calls_count:'0'}}/{{(job && job.unconfirmed_calls_count!=0)?job.unconfirmed_calls_count:'0'}}/{{(job && job.calls_count!=0)?job.calls_count:'0'}}
                                                </span>
                                            </div>
                                        </li>
                                        <li v-if="job.deleted_at == null && (getPower('editJob') || getPower('jobClone') || getPower('jobdelete'))">
                                        <div class="o-accordion-element o-accordion-link">
                                            <a v-if="getPower('editJob')" @click="editJob(job)">
                                                <el-tooltip class="item" effect="dark" content="Edit" placement="top-end">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                                </el-tooltip>
                                                </a>
                                                <a v-if="getPower('jobClone')" @click="cloneJob(job)">
                                                <el-tooltip class="item" effect="dark" content="Clone" placement="top-end">
                                                    <i class="fa fa-files-o" aria-hidden="true"></i>
                                                </el-tooltip>
                                                </a>
                                                <a v-if="getPower('jobdelete')" @click="deleteJob(job)">
                                                <el-tooltip class="item" effect="dark" content="Delete" placement="top-end">
                                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                </el-tooltip>
                                            </a>
                                        </div>
                                        </li>
                                        <li v-if="job.deleted_at == null" :class="{'o-icon-right-2nd-row': getPower('editJob') || getPower('jobClone') || getPower('jobdelete')}">
                                            <div class="o-accordion-element o-accordion-link">
                                                <a href="javascript: void(0)" @click="goToAddCalls(job)" v-if="checkCalls(job)">
                                                    <el-tooltip class="item" effect="dark" content="Add-Calls" placement="top-end">
                                                        <i class="fa fa-table" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                                <a href="javascript: void(0)" @click="goToCalls(job)" v-else>
                                                    <el-tooltip class="item" effect="dark" content="Calls" placement="top-end">
                                                        <i class="fa fa-table" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                                <a href="javascript: void(0)" @click="goToPhoneSheet(job)">
                                                    <el-tooltip class="item" effect="dark" content="Phone Sheet" placement="top-end">
                                                        <i class="fa fa-commenting-o o-clock-font" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                                <a @click="gcsSignInSheet(job.id)" href="javascript: void(0)">
                                                    <el-tooltip class="item" effect="dark" content="Sign In Sheet" placement="top-end">
                                                        <i class="fa fa-clock-o o-clock-font" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                            </div>
                                        </li>
                                        <li v-if="job.deleted_at != null">
                                            <div class="o-accordion-element o-accordion-link">
                                                <a v-if="getPower('restoreJob')" @click="restoreJob(job)">
                                                    <el-tooltip class="item" effect="dark" content="Restore Job" placement="top-end">
                                                        <i class="fa fa-repeat" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="o-filtersilder-area" @click="filterSliderArea()">
        <a href="javascript:void(0)" class="o-filter-close" @click="filterClose()"><i class="fa fa-times" aria-hidden="true"></i></a>
        <div class="o-filterslider-container" @click="filterSliderContainer($event)">
            <h1 class="h1 o-filter-heading">Filter</h1>
            <form>
                <div class="form-group o-filter-form">
                    <label for="startDate">Start date:</label>
                    <el-date-picker
                        type="date"
                        :placeholder="getDatePlaceholder()"
                        style="width: 100%;"
                        v-model="jobFilter.startDate"
                        :format="getDisplayFormat()"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>

                <div class="o-filter-form">
                    <h5 class="h5">Direction:</h5>
                    <div class="radio form-group">
                        <label>
                            Back in time
                            <input type="radio" name="Direction" value="desc" v-model="jobFilter.direction">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                    <div class="radio form-group">
                        <label>
                            Forward in time
                            <input type="radio" name="Direction" value="asc" v-model="jobFilter.direction">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                </div>

                <div class="o-filter-form">

                    <h5 class="h5">Conditions:</h5>

                    <div class="radio form-group">
                        <label>
                            By employer
                            <input type="radio" name="Conditions" value="employer" v-model="jobFilter.conditionType">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                        <div v-if="jobFilter.conditionType=='employer'" class="common-label-input--modalwidth o-custom-dropdown js-filter-drop-toggle">
                            <select v-model="jobFilter.conditionValue" class="form-control">
                                <option v-for="(employer,index) in employers" :key="index" :value="employer.employer_id">{{employer.employer.name}}</option>
                            </select>
                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                        </div>
                    </div>
                    <div class="radio form-group js-hidden-textfield" id="conditionVenue" @click="hiddenTextfield($event, 'conditionVenue')">
                        <label>
                            By venue
                            <input type="radio" name="Conditions" value="venue" v-model="jobFilter.conditionType">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    <div v-if="jobFilter.conditionType=='venue'" class="common-label-input--modalwidth o-custom-dropdown js-filter-drop-toggle">
                            <select v-model="jobFilter.conditionValue" class="form-control">
                                <option v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.name}}</option>
                            </select>
                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                        </div>
                    </div>
                    <div class="radio form-group js-hidden-textfield" id="conditionPayroll" @click="hiddenTextfield($event, 'conditionPayroll')">
                        <label>
                            By payroll
                            <input type="radio" name="Conditions" value="payroll" v-model="jobFilter.conditionType">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    <div v-if="jobFilter.conditionType=='payroll'" class="common-label-input--modalwidth o-custom-dropdown js-filter-drop-toggle">
                            <select v-model="jobFilter.conditionValue" class="form-control">
                                <option v-for="(payroll,index) in payrolls" :key="index" :value="payroll.id">{{payroll.name}}</option>
                            </select>
                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                        </div>
                    </div>
                    <div class="radio form-group js-hidden-textfield" id="conditionSteward" @click="hiddenTextfield($event, 'conditionSteward')">
                        <label>
                            By steward
                            <input type="radio" name="Conditions" value="steward" v-model="jobFilter.conditionType">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                        <div v-if="jobFilter.conditionType=='steward'" class="common-label-input--modalwidth o-custom-dropdown js-filter-drop-toggle" style="padding-bottom: 15px;">
                            <el-select v-model="jobFilter.conditionValue" style="width:100%;" filterable placeholder="Select Steward" @blur="blur($event)">
                                <el-option
                                    v-for="(steward,index) in stewards"
                                    :key="index"
                                    :label="steward.last_name+', '+steward.first_name"
                                    v-validate="'required'"
                                    :value="steward.id">
                                </el-option>
                            </el-select>
                            </div>
                        </div>
                        <div class="radio form-group js-hidden-textfield" id="conditionCreated" @click="hiddenTextfield($event, 'conditionCreated')">
                            <label>
                                Dispatched by
                                <input type="radio" name="Conditions" value="createdBy" v-model="jobFilter.conditionType">
                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                            </label>
                        <div v-if="jobFilter.conditionType=='createdBy'" class="common-label-input--modalwidth o-custom-dropdown js-filter-drop-toggle" style="padding-bottom: 15px;">
                            <el-select v-model="jobFilter.conditionValue" @blur="blur($event)" style="width:100%;" filterable placeholder="Select Steward">
                                <el-option
                                    v-for="(steward,index) in dispatchedList"
                                    :key="index"
                                    :label="steward.last_name+', '+steward.first_name"
                                    v-validate="'required'"
                                    :value="steward.user_id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="o-filter-form">
                    <ul class="button-bearer">
                        <li>
                            <a @click="clearFilter()" class="c-common-btn">Clear</a>
                        </li>
                        <li>
                            <a @click="applyFilter()" class="c-common-btn c-common-btn--green">Apply</a>
                        </li>
                    </ul>
                </div>

            </form>
        </div>
        <div>

        </div>
    </div>

    <modal name="add-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom" width="100%">
        <div tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeAddJob()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">Add New Job</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <form>
                            <div class="row" gutter="30" >
                                <div class="col-sm-6 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Event Name:<sup>*</sup></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <input type="text" id="event-name" class="form-control" placeholder="Event Name" v-validate="{ required: true}" name="Event" v-model="addJob.title">
                                                    <span v-show="errors.has('Event') && this.validation_err!=0" class="err-msg">{{ errors.first('Event') }}</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-sm-6 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Start Date:<sup>*</sup></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <div class="row">
                                            <div class="col-sm-5 o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <el-col :span="50">
                                                        <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-validate="{required: true}"
                                                        name="StartAddDate"
                                                        v-model="addJob.start"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        >
                                                        </el-date-picker>
                                                        <span v-show="errors.has('StartAddDate') && this.validation_err!=0" class="err-msg">{{ errors.first('StartAddDate') }}</span>
                                                        </el-col>
                                                </label>
                                            </div>
                                            <div class="col-sm-2 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">End Date:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <el-col :span="50">
                                                        <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-validate="{ required: true}"
                                                        name="end"
                                                        v-model="addJob.end"
                                                        :format="getDisplayFormat()"
                                                        :picker-options="pickerOptions"
                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>
                                                        <span v-show="errors.has('end') && this.validation_err!=0" class="err-msg">{{ errors.first('end') }}</span>
                                                    </el-col>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-loading="modalDataLoad">

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Location:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <select v-validate="'required'" @blur="blur($event)" @change="addLocationDetails(addJob.venue_id)" v-model="addJob.venue_id" class="form-control" name="Location" data-vv-delay="500">
                                                    <option value="">--- Select ---</option>
                                                    <option v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                <span v-show="errors.has('Location') && this.validation_err!=0" class="err-msg">{{ errors.first('Location') }}</span>
                                            </label>
                                            <span v-if="getPower('addVenue')"><a href="javascript: void(0)" @click="addVenueAddress()" class="fl-right"><i class="fa fa-plus" aria-hidden="true"></i> Add Venue</a></span>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Location Details:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <textarea v-model="addJob.location_details" class="form-control" rows="2" placeholder="Text Area"></textarea>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer: <sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-right-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select @blur="blur($event)" @change="addEmployerContact(addJob.hiring_organization_id)" v-model="addJob.hiring_organization_id" class="form-control" v-validate="{ required: true}" name="Employer" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(employer,index) in employers" :key="index" :value="employer.employer_id">{{employer.employer.name}}</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                        <span v-show="errors.has('Employer') && this.validation_err!=0" class="err-msg">{{ errors.first('Employer') }}</span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                                </div>
                                                <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select @blur="blur($event)" v-model="addJob.payroll_id" class="form-control" name="Payroll" data-vv-delay="500">
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(payroll,index) in payrolls" :key="index" :value="payroll.id">{{payroll.name}}</option>
                                                        </select>

                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer Contact:</label>
                                        </div>
                                        <div class="col-sm-9 o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-4 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                        <select @blur="blur($event)" v-model="addJob.employer_contact" class="form-control" name="employer_contact" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(user,index) in employer_users" :key="index" :value="user.user.id">{{user.user.first_name}}</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">HTS:<!-- <sup>*</sup> --></label>
                                                </div>
                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-switch
                                                            style="display: block"
                                                            v-model="addJob.hts_flag"
                                                            active-color="#13ce66"
                                                            inactive-color="#dcdfe6"
                                                            :active-value=1
                                                            :inactive-value=0
                                                            >
                                                        </el-switch>
                                                    </div>

                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Rate:</label>
                                                </div>
                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select v-model="addJob.rate_id" class="form-control" name="rate_table" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(rate,index) in rates" :key="index" :value="rate.id">{{rate.name}}</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Steward:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-right-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-select v-model="addJob.employee_id" filterable placeholder="Select Steward" @blur="blur($event)" v-validate="{ required: true}" name="steward" data-vv-delay="500">
                                                            <el-option
                                                                v-for="(steward,index) in stewards"
                                                                :key="index"
                                                                :label="steward.last_name+', '+steward.first_name"
                                                                :value="steward.id">
                                                            </el-option>
                                                        </el-select>
                                                        <span v-show="errors.has('steward') && this.validation_err!=0" class="err-msg">{{ errors.first('steward') }}</span>
                                                    </div>
                                                </div>

                                                <div class="col-sm-4 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Deny Steward Access:<sup>*</sup></label>
                                                </div>

                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.steward_access_flag"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=0
                                                    :inactive-value=1
                                                    >
                                                    </el-switch>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Dispatched by:<sup>*</sup></label>
                                        </div>

                                        <div class="col-sm-9 o-modal-form-field">
                                            <div class="row">

                                                <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">

                                                        <el-select v-model="addJob.dispatched_by" @blur="blur($event)" filterable placeholder="Select Dispatched by" v-validate="{ required: true}" name="createdBy" data-vv-delay="500">
                                                            <el-option
                                                                v-for="(steward,index) in dispatchedList"
                                                                :key="index"
                                                                :label="steward.last_name+', '+steward.first_name"
                                                                v-validate="'required'"
                                                                :value="steward.user_id">
                                                            </el-option>
                                                        </el-select>
                                                        <span v-show="errors.has('createdBy') && this.validation_err!=0" class="err-msg">{{ errors.first('createdBy') }}</span>
                                                    </div>
                                                    </label>
                                                </div>
                                                <div class="col-sm-3 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Link Color:<sup>*</sup></label>
                                                </div>
                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-color-picker v-model="addJob.link_color"></el-color-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="global_skills">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-modal-form-field o-right-no-padding">
                                            <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                <label class="common-label-text common-label-text--modalwidth">Global Skills: </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id1" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index" :disabled="isDuplicated(position.id)">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>

                                            </div>
                                            <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id2" class="form-control" data-vv-delay="500" v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index" :disabled="isDuplicated(position.id)">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                            <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id3" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index" :disabled="isDuplicated(position.id)">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                            <div class="col-sm-1 o-right-no-padding o-left-no-padding o-modal-form-field">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-12">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                            <vue-editor 
                                                id="editor1" 
                                                class="c-common-box-shadow c-radius3" 
                                                :class="{ 'error-border': hasError }"
                                                v-model="addJob.employer_requests" 
                                                style="height: 220px;"
                                                @text-change="validateContent('employer_requests', addJob.employer_requests)"
                                            ></vue-editor>
                                            <span 
                                                v-if="error.employer_requests && error.employer_requests.hasError" 
                                                class="err-msg"
                                            >
                                                {{ error.employer_requests.message }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Comments:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                            <vue-editor 
                                                id="editor2" 
                                                class="c-common-box-shadow c-radius3" 
                                                :class="{ 'error-border': errors.comment && errors.comment.hasError }"
                                                v-model="addJob.comment" 
                                                style="height: 220px;"
                                                @text-change="validateContent('comment', addJob.comment)"
                                            ></vue-editor>
                                            <span 
                                                v-if="error.comment && error.comment.hasError" 
                                                class="err-msg"
                                            >
                                                {{ error.comment.message }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field o-common-margin-bottom15">
                                            <div class="o-pub">
                                                <label class="o-blue-medium-text">Hide in Calender:</label>
                                                <div class="toggle-btn">
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.employer_requests_private"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    >
                                                    </el-switch>
                                                </div>
                                                <label class="o-blue-medium-text o-left-padding-10"> Print With Sign in Sheet:</label>
                                                <div class="toggle-btn">
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.employer_requests_signin"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    >
                                                    </el-switch>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-12 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <sup>*</sup> Comments- ALWAYS printed with sign-in and calendar info !
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Documents:</label>
                                    </div>
                                    <div class="col-sm-8 o-left-no-padding o-modal-form-field no-right-padding">
                                        <div v-for="(file, key) in new_files" :key="key" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                            <input @change="addFileForAddNewJob($event,key)" type="file" name="myfile" />
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(new_files[key].name)}}</span>
                                                <span v-if="file.selected == true" class="addJob-drop">
                                                    <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop add-job-drop-type">
                                                        <select v-model="new_files[key].label">
                                                            <option value="Report">Report</option>
                                                            <option value="HW">HW</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                </span>
                                            </span>
                                            <a v-if="new_files.length >1" @click="removeFile(key)" class="o-choose-del-btn">
                                                <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-sm-1 o-right-no-padding o-modal-form-field o-job-add-icon">
                                        <label class="common-label-text common-label-text--modalwidth">
                                            <a @click="cloneInputfile()" class="o-choose-add-btn">
                                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <button @click="closeAddJob()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                            </li>
                            <li>
                                <button type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" @click="addSingleJob()"><i class="fa fa-plus" aria-hidden="true"></i> Add Job</button>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </modal>

    <modal name="edit-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom" width="100%">
        <div tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeEditJob()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">Edit Job</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <form>

                            <div class="row" gutter="30" v-if="!modalDataLoad">
                                <div class="col-sm-6 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Event Name:<sup>*</sup></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <input type="text" id="event-name" class="form-control" placeholder="Event Name" v-validate="{ required: true}" name="Event" v-model="addJob.title">
                                                    <span v-show="errors.has('Event') && this.validation_err!=0" class="err-msg">{{ errors.first('Event') }}</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-sm-6 o-modal-field-area">
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Start Date:<sup>*</sup></label>
                                    </div>
                                    <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                        <div class="row">
                                            <div class="col-sm-5 o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <el-col :span="50">
                                                        <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-validate="{required: true}"
                                                        name="StartAddDate"
                                                        v-model="addJob.start"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        >
                                                        </el-date-picker>
                                                        <span v-show="errors.has('StartAddDate') && this.validation_err!=0" class="err-msg">{{ errors.first('StartAddDate') }}</span>
                                                        </el-col>
                                                </label>
                                            </div>
                                            <div class="col-sm-2 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">End Date:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <el-col :span="50">
                                                        <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-validate="{ required: true}"
                                                        name="end"
                                                        v-model="addJob.end"
                                                        :format="getDisplayFormat()"
                                                        :picker-options="pickerOptions"
                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>
                                                        <span v-show="errors.has('end') && this.validation_err!=0" class="err-msg">{{ errors.first('end') }}</span>
                                                    </el-col>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-loading="modalDataLoad">
                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Location:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <select v-validate="'required'" @blur="blur($event)" @change="addLocationDetails(addJob.venue_id)" v-model="addJob.venue_id" class="form-control" name="Location" data-vv-delay="500">
                                                    <option value="">--- Select ---</option>
                                                    <option v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                <span v-show="errors.has('Location') && this.validation_err!=0" class="err-msg">{{ errors.first('Location') }}</span>
                                            </label>
                                            <span v-if="getPower('addVenue')"><a href="javascript: void(0)" @click="addVenueAddress()" class="fl-right"><i class="fa fa-plus" aria-hidden="true"></i> Add Venue</a></span>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Location Details:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                                <textarea v-model="addJob.location_details" class="form-control" rows="2" placeholder="Text Area"></textarea>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer: <sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-right-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select @blur="blur($event)" @change="addEmployerContact(addJob.hiring_organization_id)" v-model="addJob.hiring_organization_id" class="form-control" v-validate="{ required: true}" name="Employer" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(employer,index) in employers" :key="index" :value="employer.employer_id">{{employer.employer.name}}</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                        <span v-show="errors.has('Employer') && this.validation_err!=0" class="err-msg">{{ errors.first('Employer') }}</span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                                </div>
                                                <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select @blur="blur($event)" v-model="addJob.payroll_id" class="form-control" name="Payroll" data-vv-delay="500">
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(payroll,index) in payrolls" :key="index" :value="payroll.id">{{payroll.name}}</option>
                                                        </select>

                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer Contact:</label>
                                        </div>
                                        <div class="col-sm-9 o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-4 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                        <select @blur="blur($event)" v-model="addJob.employer_contact" class="form-control" name="employer_contact" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(user,index) in employer_users" :key="index" :value="user.user.id">{{user.user.first_name}}</option>
                                                            
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                       
                                                    </div>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">HTS:<!-- <sup>*</sup> --></label>
                                                </div>
                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        
                                                        <el-switch
                                                            style="display: block"
                                                            v-model="addJob.hts_flag"
                                                            active-color="#13ce66"
                                                            inactive-color="#dcdfe6"
                                                            :active-value=1
                                                            :inactive-value=0
                                                            >
                                                        </el-switch>
                                                       
                                                    </div>
                                                </div>

                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <select v-model="addJob.rate_id" class="form-control" name="rate_table" data-vv-delay="500">
                                                            <option value="">--- Select ---</option>
                                                            <option v-for="(rate,index) in rates" :key="index" :value="rate.id">{{rate.name}}</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Steward:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-right-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-select v-model="addJob.employee_id" filterable placeholder="Select Steward" @blur="blur($event)" v-validate="{ required: true}" name="steward" data-vv-delay="500">
                                                            <el-option
                                                                v-for="(steward,index) in stewards"
                                                                :key="index"
                                                                :label="steward.last_name+', '+steward.first_name"
                                                                :value="steward.id">
                                                            </el-option>
                                                        </el-select>
                                                        
                                                        <span v-show="errors.has('steward') && this.validation_err!=0" class="err-msg">{{ errors.first('steward') }}</span>
                                                    </div>
                                                </div>

                                                <div class="col-sm-4 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Deny Steward Access:<sup>*</sup></label>
                                                </div>

                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.steward_access_flag"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=0
                                                    :inactive-value=1
                                                    >
                                                    </el-switch>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Dispatched by:<sup>*</sup></label>
                                        </div>

                                        <div class="col-sm-9 o-modal-form-field">
                                            <div class="row">

                                                <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">

                                                        <el-select v-model="addJob.dispatched_by" @blur="blur($event)" filterable placeholder="Select Dispatched by" v-validate="{ required: true }" name="createdBy" data-vv-delay="500">
                                                            <el-option
                                                                v-for="(steward,index) in dispatchedList"
                                                                :key="index"
                                                                :label="steward.last_name+', '+steward.first_name"
                                                                :value="steward.user_id">
                                                            </el-option>
                                                        </el-select>
                                                       
                                                        <span v-show="errors.has('createdBy') && this.validation_err!=0" class="err-msg">{{ errors.first('createdBy') }}</span>
                                                    </div>
                                                    </label>
                                                </div>
                                                <div class="col-sm-3 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">Link Color:<sup>*</sup></label>
                                                </div>
                                                <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-color-picker v-model="addJob.link_color"></el-color-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="this.global_skills">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                <label class="common-label-text common-label-text--modalwidth">Global Skills: </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="col-sm-3 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id1" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>

                                            </div>
                                            <div class="col-sm-2 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id2" class="form-control" data-vv-delay="500" v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                            <div class="col-sm-3 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                <select @blur="blur($event)" v-model="addJob.skill_id3" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                    <option value="" label="--- Select ---"></option>
                                                    <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                            <div class="col-sm-1 o-right-no-padding o-left-no-padding o-modal-form-field">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-12">
                            
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                            <vue-editor 
                                                id="editor3" 
                                                class="c-common-box-shadow c-radius3" 
                                                :class="{ 'error-border': hasError }"
                                                v-model="addJob.employer_requests" 
                                                style="height: 220px;"
                                                @text-change="validateContent('edit_employer_requests', addJob.employer_requests)"
                                            ></vue-editor>
                                            <span 
                                                v-if="error.edit_employer_requests && error.edit_employer_requests.hasError" 
                                                class="err-msg"
                                            >
                                                {{ error.edit_employer_requests.message }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Comments:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                            <vue-editor 
                                                id="editor4" 
                                                class="c-common-box-shadow c-radius3" 
                                                :class="{ 'error-border': hasError }"
                                                v-model="addJob.comment" 
                                                style="height: 220px;"
                                                @text-change="validateContent('edit_content', addJob.comment)"
                                            ></vue-editor>
                                            <span 
                                                v-if="error.edit_content && error.edit_content.hasError" 
                                                class="err-msg"
                                            >
                                                {{ error.edit_content.message }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field o-common-margin-bottom15">
                                            <div class="o-pub">
                                                <label class="o-blue-medium-text">Hide in Calender:</label>
                                                <div class="toggle-btn">
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.employer_requests_private"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    >
                                                    </el-switch>
                                                </div>
                                                <label class="o-blue-medium-text o-left-padding-10"> Print With Sign in Sheet:</label>
                                                <div class="toggle-btn">
                                                    <el-switch
                                                    style="display: block"
                                                    v-model="addJob.employer_requests_signin"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value=1
                                                    :inactive-value=0
                                                    >
                                                    </el-switch>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                        <div class="col-sm-12 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <sup>*</sup> Comments- ALWAYS printed with sign-in and calendar info !
                                                       
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <button @click="closeEditJob()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                            </li>
                            <li>
                                <button type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" @click="editSingleJob()"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>

    <modal name="clone-job"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div  tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeCloneJob()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title">Clone a Job</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="h2 text-center">{{cloneJobTitle}}</h2>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr class="o-modal-separetor" />
                                    </div>
                                </div>
                                <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                    <p class="ps2">This tool will create a new job, and duplicate all information and calls from a pre-existing job in the database. If 'copy assignments' is selected, it will also attempt to assign the same employees to the job, and alert you if schedule conflicts are found.</p>
                                    <p class="ps2">Choose the start date of the new job, and hit 'Clone' to generate the new job.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <hr class="o-modal-separetor" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Clone to:</label>
                                    <label class="common-label-input">
                                        <el-date-picker
                                            name="date"
                                            class="custom_date"
                                            v-validate="{ required: true}"
                                            v-model="cloneDate"
                                            type="date"
                                            :format="getDisplayFormat()"
                                            value-format="yyyy-MM-dd"
                                            :placeholder="getDatePlaceholder()">
                                        </el-date-picker>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text o-auto-width">Copy assignments?</label>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            <input type="checkbox" id="checkbox" v-model="cloneAssignment">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a @click="closeCloneJob()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a @click="saveCloneJob" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-files-o" aria-hidden="true"></i> Clone Job</a>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>
        </div>
    </modal>

    <el-dialog
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <span>Do you want to notify after delete the job?</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="deleteWithNotify=false; dialogFormVisible=true; centerDialogVisible = false;">Delete</el-button>
            <el-button type="primary" @click="deleteWithNotify=true; dialogFormVisible=true; centerDialogVisible = false;">Delete & Notify</el-button>
        </span>
    </el-dialog>

    <el-dialog
        :visible.sync="restorerDialogVisible"
        width="30%"
        center>
        <span>Do you want to Review / Restore Deleted job?</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="preview()">Review</el-button>
            <el-button type="primary" @click="confirmRestore('dispatch')">Restore</el-button>
            <el-button @click="restorerDialogVisible=false">Cancel</el-button>
        </span>
    </el-dialog>

    <el-dialog title="Are You Sure?" :visible.sync="dialogFormVisible" class="con-job-popup">
        <span>Deleted job will have to be manually restored by support.</span>
        <el-form v-if="selectedJob">
            <el-form-item label="Enter the Job Name to Delete:">
                <el-input v-model="verifyedJobName" :placeholder="selectedJob.title" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">Cancel</el-button>
            <el-button type="primary" @click="confirmDelete()">Delete</el-button>
        </span>
    </el-dialog>

    <modal name="edit-job-add-note" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div tabindex="-1" role="dialog">
            <div role="document" v-loading="modalLoading">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button @click="closeEditJobNote()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">Add Notes</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="common-input--fullwidth">
                                        <textarea class="form-control" rows="4" placeholder="Enter your note" name="note" v-model="editJobAddNote.note"></textarea>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEditJobNote()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="editJobAddNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>
        </div>
    </modal>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import { VueEditor } from 'vue2-editor';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import { generateReportAsync } from '../../reportTaskPoller';
    import { global } from '../../global.js';
    let timeout = null;
    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userToken2: 'userToken2',
                userRole: 'userRole',
                userClientID: 'userClientID',
                loginUserName: 'userName',
                employeeId: 'employeeId',
                userClientName: 'userClientName',
                userID: 'userID',
                userName: 'userName',
                userFullName: 'userFullName',
                clientUserId: 'clientUserId',
                getSelectedJobFilter: 'getSelectedJobFilter',
                getOpenJob: 'getOpenJob',
                userRoleSlug: 'userRoleSlug',
				isLoginSuper: 'isLoginSuper'
            }),
        },

        components: {
            VueEditor,
        },

        data() {
            const dataProps = {
                domReady: false,
                windowWidth: '',
                modalLoading: false,
                positions: [],
                tempDeletedJobs: null,
                deleted_jobs: 0,
                sortType:"",
                centerDialogVisible:false,
                selectedJobId:'',
                preSelectedTab:{
                    parent:'Myjob',
                    child:'day'
                },
                modalDataLoad:false,
                isSteward:0,
                isDispatcher: 0,
                newJobId:'',
                myJobDisplay:true,
                timeout: null,
                searchData: [],
                searchBox: '',
                afterAPI: false,
                loading: false,
                monthSort: new Date(),
                jobList: [],
                jobListForPDF: [],
                next_page: null,
                current_page:0,
                storeMore: [],
                csv: '',
                jobFilter: {
                    startDate: new Date(),
                    direction: 'desc',
                    resultPerPage: '25',
                    conditionType: 'employer',
                    conditionValue: '',
                },
                addJob: {
                    title: '',
                    hiring_organization_id: '',
                    payroll_id: '',
                    employer_contact: '',
                    rate_id: '',
                    link_color: '#335479',
                    employee_id: '',
                    created_by: '',
                    dispatched_by: '',
                    start: '',
                    end: '',
                    venue_id: '',
                    location_details: '',
                    employer_requests: '',
                    employer_requests_private: '',
                    employer_requests_signin: '',
                    comment: '',
                    comment_private: '',
                    hts_flag: 0,
                    steward_access_flag: 1,
                },
                validation_err: 0,
                value4: true,
                job: [],
                venues: [],
                employers: [],
                employees: [],
                payrolls: [],
                stewards: [],
                dispatchedList: [],
                employer_users:[],
                files: [{
                    file: 'No file chosen'
                }, ],
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                editJobId: '',
                cloneJobId: '',
                cloneJobTitle:'',
                cloneDate: '',
                cloneAssignment: true,
                verifyedJobName:'',
                selectedJob:null,
                deleteWithNotify: false,
                dialogFormVisible:false,
                restorerDialogVisible:false,
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: new Date(dataProps.addJob.start).setDate(new Date(dataProps.addJob.start).getDate() - 1)
                    };
                },
                global_skills: null,
                clientData: null,
                afMasterEnabled: 0,
                userDateFormat: null,
                userTimeFormat:null,
                editJobAddNote: {
                    note: ''
                },
                editJobAction: '',
                editJobFormData: null,
                publishedJobId: null,
                publishedJobStatus: '',
                rates:[],
                contentRendered: false,
                progress: 0,
                generatingPdf: false,
                pdfDownloaded: false,
                viewCallsUrlList: [],
                htmlToPdfOptions:  {
                    enableLinks: true,
                    filename: 'monthly_pdf_archive.pdf'
                },
                pdfArchiveLoading: false,
                hasError: false,
                error: {},
                jobListLoading: false
            }
            return dataProps;
        },

        async created() {
            await this.getClientData();
            this.preSelectedTab=this.getSelectedJobFilter;
            this.checkDispatcher();
            this.checkSteward();

            if(this.userRoleSlug=='employee' && this.preSelectedTab.parent!='Myjob')
                this.changeTab('Myjob', 'day', false);
            else
                this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, false);

            this.getEmpDetails();

            this.getRates();

            this.windowResizeHandler();

            window.addEventListener("resize", this.windowResizeHandler);
        },

        methods: {
            /**
             * Which column does the chosen payroll id belong to?
             *
             * getPayrollDropdown returns client payrolls AND employers flagged
             * is_payroll_company, each tagged with `source`. An employer id must NOT
             * go into jobs.payroll_id -- that column means the legacy `payrolls`
             * entity, and Job::payroll() would resolve to null, blanking the payroll
             * on job details and in reports. The server routes on this value.
             */
            payrollSourceFor(id) {
                if (!id) return '';
                var hit = (this.payrolls || []).find(function (p) { return p.id === id; });
                return hit ? (hit.source || '') : '';
            },

            windowResizeHandler() {
                setTimeout(()=>{
                    this.windowWidth = window.screen.availWidth;
                    if(this.windowWidth<1024) {
                        let selectedElement1 = document.getElementsByClassName("o-datepicker-input")[0];
                        selectedElement1.getElementsByClassName('el-input__inner')[0].style.width='80px';
                        let selectedElement2 = document.getElementById("filter-buttons-row").getElementsByTagName("li");
                        for (var i = 0; i < selectedElement2.length; i++) {
                            selectedElement2[i].style.marginRight="2px";
                        }
                        let selectedElement3 = document.getElementsByClassName("o-job-sort-btn-position")[0];
                        selectedElement3.style.textAlign='left';
                        let selectedElement4 = selectedElement3.getElementsByTagName("li");
                         for (var i = 0; i < selectedElement4.length; i++) {
                            selectedElement4[i].style.marginRight="2px";
                        }
                    }
                }, 2000);
            },

            getUserDateTimeFormat(jobDateTime) {
                return dateTimeConvert.getUserDateTime(jobDateTime);
            },

            getJobBackgroundClass(job) {
                let jobStatusClass = 'new-admin-event-head-orange';
                if(job.calls_count > 0) {
                    if(job.unconfirmed_calls_count == 0 && job.unassigned_calls_count == 0)
                        jobStatusClass='new-admin-event-head-green';
                }
                return jobStatusClass;
            },

            displayPdfArchiveIcon(job) {
                let status = false;
                if(job.calls_count > 0) {
                    if(job.unconfirmed_calls_count == 0 && job.unassigned_calls_count == 0)
                        status = true;
                }
                return status;
            },

            getJobIndicatorBackgroundClass(job) {
                 let jobStatusClass = 'new-admin-event-head-orange';
                if(job.calls_count > 0) {
                    if(job.unconfirmed_calls_count == 0 && job.unassigned_calls_count == 0)
                        jobStatusClass='new-admin-event-head-green';
                    else if(job.unconfirmed_calls_count > 0)
                        jobStatusClass='new-admin-event-head-teal';
                }
                return jobStatusClass;
            },

            getEmpDetails() {
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.employeeName=res.data.result.employable.first_name+" "+res.data.result.employable.last_name;
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                }).catch((err) => {
                    console.log(err);
                });
            },

            getRates() {
                service.get('getRates', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.rates = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getClientData() {
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.global_skills = this.clientData.global_skills;
                    this.afMasterEnabled = parseInt(this.clientData.af_enabled) ? 1 : 0;
                }).catch((err) => {
                    console.log(err);
                });
            },

            onChangeAfMaster() {
                service.post('client/updateAfEnabled', {
                    af_enabled: this.afMasterEnabled
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.$notify({ type: 'success', message: 'Auto-Fill ' + (this.afMasterEnabled ? 'enabled' : 'disabled') });
                }).catch((err) => {
                    console.log(err);
                    this.$notify({ type: 'error', message: 'Failed to update Auto-Fill setting' });
                    this.afMasterEnabled = this.afMasterEnabled ? 0 : 1;
                });
            },

            toggleJobAf(job) {
                service.post('job/updateJobAutoFill', {
                    job_id: job.id,
                    af_onoff: job.af_onoff
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.$notify({ type: 'success', message: 'Job Auto-Fill ' + (job.af_onoff ? 'on' : 'off') });
                }).catch((err) => {
                    console.log(err);
                    this.$notify({ type: 'error', message: 'Failed to update job Auto-Fill' });
                    job.af_onoff = job.af_onoff ? 0 : 1;
                });
            },

            isDuplicated(id) {
                if(this.addJob.skill_id1 != "" && id == this.addJob.skill_id1) {
                    return true;
                }
                else if(this.addJob.skill_id2 != "" && id == this.addJob.skill_id2) {
                    return true;
                }
                else if(this.addJob.skill_id3 != "" && id == this.addJob.skill_id3) {
                    return true;
                }
                return false;
            },

            addVenueAddress() {
                this.$router.push({
                    'path': '/addVenue'
                });
            },

            changeDeletedJobSwitch() {
                if(this.searchBox !== '') {
                    this.updateValue();
                }else if(this.userRoleSlug=='employee' && this.preSelectedTab.parent!=='')
                    this.changeTab('Myjob', 'day', false);
                else
                    this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, false);
            },

            testingTheSwitch() {},

            copyText(job){
                var textarea = document.createElement("textarea");
		        textarea.textContent = 'Job Id: '+ job.id+', Venue Id: '+ job.venue_id+', Employer Id: '+job.employer_id;
		        textarea.style.position = "fixed";
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		            document.execCommand("copy");
		            this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });

		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },

            copyViewCallsUrls(jobIds){
                var textarea = document.createElement("textarea");
		        textarea.textContent = '';
                jobIds.forEach((item) => {
                    textarea.textContent += item+'\r\n';
                });
		        textarea.style.position = "fixed"; 
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		            document.execCommand("copy"); 
		            this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });

		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },

            async gcsSignInSheet(jobId){
                this.loading = true;
                try {
                    const task = await generateReportAsync('signin_sheet', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }, { job_id: jobId });
                    this.loading = false;
                    let data_source = task.gcs_path;
                    let redirectUrl = dateTimeConvert.getSignInSheetUrl('jobReports/', data_source);
                    redirectUrl = redirectUrl + '&token=' + btoa(this.userToken2) + "&job=" + btoa(jobId) + "&api_base_url=" + btoa(global[0].BASE_URL);
                    window.open(redirectUrl, "_blank");
                } catch (err) {
                    this.loading = false;
                    this.$notify.error({ title: 'Error', message: err.message || 'Failed to generate report' });
                }
            },

            updateValue(){
                clearTimeout(timeout);
                if(!this.searchBox){
                    this.preSelectedTab=this.getSelectedJobFilter;
                    this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, false);
                    return;
                }

                if(this.searchBox === '') {
                    this.preSelectedTab=this.getSelectedJobFilter;
                    this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, false);
                    return;
                }

                this.jobList = [];
                this.storeMore=[];
                this.loading = true;
                this.afterAPI = false;
                this.next_page = null;
                this.preSelectedTab.parent = 'Alljob'
                this.preSelectedTab.child = 'search';

                if((this.isSteward||this.isDispatcher)&&this.userRoleSlug=='employee') {
                    timeout = setTimeout(() => {
                        service.get('job/jobSearch', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'jobSearch': this.searchBox,
                            'show-deleted-jobs': this.deleted_jobs
                        }).then((res) => {
                            this.jobList = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                            this.loading = false;
                            this.afterAPI = true;
                            if (this.next_page != null) {
                                service.getUrl(this.next_page, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'jobSearch': this.searchBox,
                                    'show-deleted-jobs': this.deleted_jobs
                                })
                                .then((res) => {
                                    this.storeMore = res.data.result.data;
                                    this.next_page = res.data.result.next_page_url;

                                }).catch((err) => {
                                    console.log(err);
                                })
                            }
                        }).catch((err) => {
                            console.log(err);
                        })
                    }, 2000);
                }else {
                    timeout = setTimeout(() => {
                        service.get('job/jobSearch', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'jobSearch': this.searchBox,
                            'show-deleted-jobs': this.deleted_jobs
                        }).then((res) => {
                            this.jobList = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                            this.loading = false;
                            this.afterAPI = true;
                            if (this.next_page != null) {
                                service.getUrl(this.next_page, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'jobSearch': this.searchBox,
                                    'show-deleted-jobs': this.deleted_jobs
                                })
                                .then((res) => {
                                    this.storeMore = res.data.result.data;
                                    this.next_page = res.data.result.next_page_url;

                                }).catch((err) => {
                                    console.log(err);
                                })
                            }
                        }).catch((err) => {
                            console.log(err);
                        })
                    }, 2000);
                }
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },

            checkSteward(){
                service.get('employee/'+this.employeeId +'/checkSkill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.isSteward=res.data.result;
                    if((this.isSteward == 0 && this.isDispatcher == 0) && this.userRoleSlug=='employee'){
                        this.$router.push({
                            path: `/`
                        });
                    }
                }).catch((err) => {
                    this.$Progress.fail();
                });
            },

            checkDispatcher() {
                this.isDispatcher = null;
                service
                    .get("employee/" + this.employeeId + "/checkDispatchBySkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                    })
                    .then((res) => {
                        this.isDispatcher = res.data.result;
                        this.$forceUpdate();
                    })
                    .catch((err) => {
                    this.$Progress.fail();
                    });
            },

            getSelectedTab(){
                this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, false);
            },

            sortBy(type){
                this.sortType = type;
                this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, true);
            },

            changeTab(parent, child, sort){
                if(!sort){
                    this.sortType = '';
                }
                this.searchBox = '';
                this.preSelectedTab.parent=parent;
                this.preSelectedTab.child=child;
                this.$store.dispatch('setSelectedJobFilter', {'parent':this.preSelectedTab.parent, 'child': this.preSelectedTab.child});
                switch(parent){
                    case 'Myjob':
                        switch(child){
                            case "incomplete":
                                this.jobList=[];
                                this.getMyJobIncomplete();
                                break;
                            case "day":
                                this.jobList=[];
                                this.getMyJobNext45();
                                break;
                            case "month":
                                this.jobList=[];
                                this.getMyJobByMonth();
                                break;
                            case "today":
                                this.jobList=[];
                                this.getMyJobsByToday();
                                break;
                            case "tomorrow":
                                this.jobList=[];
                                this.getMyJobsByTomorrow();
                                break;
                            default:
                            // console.log('My job default');
                        }
                        break;
                    case 'Alljob':
                        switch(child){
                            case "incomplete":
                                this.jobList=[];
                                this.getIncompleteJob();
                                break;
                            case "day":
                                this.jobList=[];
                                this.allJob();
                                break;
                            case "month":
                                this.jobList=[];
                                this.getJobByMonth();
                                break;
                            case "today":
                                this.jobList=[];
                                this.getJobByToday();
                                break;
                            case "tomorrow":
                                this.jobList=[];
                                this.getJobByTomorrow();
                                break;
                            default:
                            // console.log('All job default');
                        }
                        break;
                    default:
                        // console.log('root job default');
                }
            },

            getMyJobIncomplete(){
                this.monthSort = "";
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                this.storeMore =[];
                service.get('job/myIncompleteJob', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.employeeId,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then((res) => {
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'employee-id': this.employeeId,
                                'sort-type': this.sortType,
                                'show-deleted-jobs': this.deleted_jobs
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            })
                    }

                }).catch((err) => {
                    console.log(err);
                    this.afterAPI = true;
                    this.loading = false;
                })
            },

            getMyJobNext45(){
                this.monthSort = "";
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job/myJobNext45Days', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.employeeId,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-id': this.employeeId,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }

                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            getMyJobByMonth(){
                this.loading = true;
                this.afterAPI = false;
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }
                const month = moment(this.monthSort).month() + 1;
                const year = moment(this.monthSort).year();
                this.jobList=[];
                service.get('job/myJobByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.employeeId,
                    'month': month,
                    'year': year,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-id': this.employeeId,
                            'month': month,
                            'year': year,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            lastOpenAccordian(key){
                var index = this.jobList.findIndex(job => job.id == key);
                if(index!=-1){
                    this.$store.dispatch('setLastOpenJob', index);
                }else{
                    this.$store.dispatch('setLastOpenJob', 0);
                }
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            getAddJobPower() {
                let result = false;
                if(this.getPower('addJob')) {
                    result = true;
                }
                if(this.userRoleSlug == 'employee' && this.isSteward == 1 && this.clientData && this.clientData.power_steward) {
                    result = true;
                }else if(this.userRoleSlug == 'employee'){
                    result = false;
                }
                return result;
            },

            getJobFiltersPower() {
                if(this.userRoleSlug=='power-user' || this.userRoleSlug=='power-user-minus' || this.userRoleSlug=='client-admin' || this.userRoleSlug=='super-admin') {
                    return true;
                }
                return false;
            },

            getTitleDate(dateTime) {
                return moment.utc(dateTime).format('MM/DD/YY');
            },

            getUserDateFormat(date) {
                return dateTimeConvert.localDate(date,this.userDateFormat);
            },

            myJob(){
                this.getMyJob();
            },

            getMyJob() {
                this.jobList=[];
                this.loading = true;
                this.afterAPI = false;
                service.get('job/myJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'employee-id': this.employeeId,
                        'sort-type': this.sortType
                })
                .then((res) => {
                    if(this.preSelectedTab.parent == 'Myjob'){
                        this.loading = false;
                        this.afterAPI = true;
                        this.jobList = res.data.result.data;
                    }

                    if(res.data.result.length==0){
                        if(this.$cookies.get('csLogin') != 'employee'){
                            this.allJob();
                            this.myJobDisplay=false;
                        }
                    }
                    this.next_page = res.data.result.next_page_url;
                    this.storeMore = [];
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-id': this.employeeId,
                            'sort-type': this.sortType
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            allJob() {
                this.getJobByDay();
            },

            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },

            querySearch(queryString, cb) {
                var searchData = this.searchBox;
                if (searchData.length > 2) {
                    service.get('job/jobSearch', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'jobSearch': searchData,
                            'sort-type': this.sortType
                        })
                        .then((res) => {
                            this.searchData = res.data.result;
                        }).catch((err) => {
                            console.log(err);
                        })
                    let searchItem = [];
                    this.searchData.forEach(function(event) {
                        let temp = {
                            value: event.title,
                            id: event.id,
                        };
                        searchItem.push(temp);
                    });

                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        cb(searchItem);
                    }, 3000 * Math.random());
                }

            },

            handleSelect(item) {

                let selectedJob = this.searchData.filter(function(job) {
                    return (job.id === item.id);
                });
                this.$store.dispatch('setJob', selectedJob[0]);
                this.$router.push({
                    path: `/jobDetails/`+btoa(selectedJob[0].id)
                });
            },

            uploadCSV(e) {
                var input = e.target;
            },

            getIncompleteJob() {
                this.monthSort = "";
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                this.storeMore =[];
                service.get('job/incompleteJobs', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then(async (res) => {
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        await service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'sort-type': this.sortType,
                                'show-deleted-jobs': this.deleted_jobs
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            })
                    }

                }).catch((err) => {
                    console.log(err);
                    this.afterAPI = true;
                    this.loading = false;
                })
            },

            getJobByDay() {
                this.monthSort = "";
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }

                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            getNext(){
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }else{
                    this.monthSort=moment(this.monthSort).add(1, 'M').toISOString();
                }
                this.changeTab(this.preSelectedTab.parent, 'month', false);
            },

            getPrev(){
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }else{
                    this.monthSort=moment(this.monthSort).subtract(1, 'M').toISOString();
                }
                this.changeTab(this.preSelectedTab.parent, 'month', false);
            },

            async getJobByMonth() {
                this.loading = true;
                this.afterAPI = false;
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }
                const month = moment(this.monthSort).month() + 1;
                const year = moment(this.monthSort).year();
                this.jobList=[];
                await service.get('job/jobByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'month': month,
                    'year': year,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs,
                    'pagination': 1
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'month': month,
                            'year': year,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs,
                            'pagination': 1
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            async getJobByMonthForPDF() {
                if(this.preSelectedTab.child != 'month') {
                    this.$notify({
                        title: 'Error',
                        message: 'Please Select Month',
                        type: 'error'
                    });
                    return;
                }
                if(this.monthSort==''){
                    this.monthSort = new Date();
                }
                const month = moment(this.monthSort).month() + 1;
                const year = moment(this.monthSort).year();
                await service.get('job/jobByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'month': month,
                    'year': year,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs,
                    'pagination': 0
                })
                .then(async (res) => {
                    this.jobListForPDF = res.data.result;
                    await this.monthlyPDFArchive();
                }).catch((err) => {
                    this.pdfArchiveLoading = false;
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            async monthlyPDFArchive() {
                this.viewCallsUrlList = [];
                if(this.jobListForPDF.length){
                    let viewCallsUrls = []
                    let index = 0;
                    let url = window.location.href.split('#')[0]+'#/viewCalls/';
                    await this.jobListForPDF.forEach((obj) => {
                        let tempObj = {
                            sr_no: index + 1,
                            calls_url: url+btoa(obj.id),
                            job_number: obj.job_number,
                            job_id: obj.id,
                            job_name: obj.title,
                        }
                        viewCallsUrls.push(tempObj);
                        index += index;
                    });
                    index=0;
                    this.jobListForPDF = []
                    this.viewCallsUrlList = [ ...viewCallsUrls ];
                    console.log("Check function call");
                    this.$forceUpdate();
                }else{
                    this.$notify({
                        title: 'Error',
                        message: 'No Jobs in the given Month',
                        type: 'error'
                    });
                }
            },

            getJobByToday() {
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job/getAllJobsToday', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'month': month,
                            'year': year,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            getMyJobsByToday() {
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job/getAllMyJobsToday', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs,
                    'employee-id': this.employeeId
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs,
                            'employee-id': this.employeeId
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            getJobByTomorrow() {
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job/getAllJobsTomorrow', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs,
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            getMyJobsByTomorrow() {
                this.loading = true;
                this.afterAPI = false;
                this.jobList=[];
                service.get('job/getAllMyJobsTomorrow', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.sortType,
                    'show-deleted-jobs': this.deleted_jobs,
                    'employee-id': this.employeeId
                })
                .then((res) => {
                    this.loading = false;
                    this.jobList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.sortType,
                            'show-deleted-jobs': this.deleted_jobs,
                            'employee-id': this.employeeId
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },

            addEmployerContact(id) {
                service.get('employer/'+id+'/getAllEmployerUsersListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    let self =this;
                    this.employer_users=res.data.result.employer_users;
                    this.employer_users.forEach(function(user) {
                        if(user.user.role.name == 'Employer Admin'){
                            self.addJob.employer_contact = user.user.id;
                        }
                    });

                }).catch((err) => {
                    console.log(err);
                })
            },

            addLocationDetails(id) {
                var index = this.venues.findIndex(venue => venue.id == id);
                if (index != -1) {
                    this.addJob.location_details = (this.venues[index].addresses&&this.venues[index].addresses.length) ? this.venues[index].addresses[0].address : "NA";
                }
            },

            getDate(str) {
                return dateTimeConvert.localDate(str);
            },

            async handleScroll(position) {
                if (position !== "bottom") return;
                await this.loadMore();
            },

            async loadMore() {
                if(this.storeMore.length){
                    this.jobList.push(...this.storeMore);
                }
                this.storeMore=[];
                if(this.preSelectedTab.child == 'filter'){
                    this.getFilterPagination();
                }else if (this.next_page != null) {
                    const month = new Date(this.monthSort).getMonth() + 1;
                    const year = new Date(this.monthSort).getFullYear();
                    await service.getUrl(this.next_page, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'employee-id': this.employeeId,
                        'month': month,
                        'year': year,
                        'sort-type': this.sortType,
                        'show-deleted-jobs': this.deleted_jobs,
                        'pagination': 1
                    }).then((res) => {
                        this.storeMore = res.data.result.data;
                        this.next_page = res.data.result.next_page_url;
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.storeMore = [];
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
                  
            addSingleJob() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validateContent('employer_requests', this.addJob.employer_requests);
                        this.validateContent('content', this.addJob.comment);
                        if (this.hasValidationErrors()) {
                            this.$notify.error({
                                title: 'Error', 
                                message:'Please fix validation errors before saving.'}
                            ); 
                            return;                         
                        }
                        this.validation_err = 0;
                        let fromData = {
                            title: this.addJob.title,
                            employer_id: this.addJob.hiring_organization_id,
                            payroll_id: this.addJob.payroll_id,
                            payroll_source: this.payrollSourceFor(this.addJob.payroll_id),
                            employer_user_id: this.addJob.employer_contact,
                            link_color: this.getColor(this.addJob.link_color),
                            employee_id: this.addJob.employee_id,
                            created_by: this.userID,
                            dispatched_by: this.addJob.dispatched_by,
                            start: this.addJob.start + " " + Date().slice(16, 24),
                            end: this.addJob.end + " " + Date().slice(16, 24),
                            venue_id: this.addJob.venue_id,
                            location_details: this.addJob.location_details,
                            employer_requests: this.addJob.employer_requests,
                            employer_requests_private: this.addJob.employer_requests_private,
                            employer_requests_signin: this.addJob.employer_requests_signin,
                            comment: this.addJob.comment,
                            comment_private: (this.addJob.comment_private) ? 1 : 0,
                            serial: '',
                            label: this.addJob.label,
                            hts_flag: this.addJob.hts_flag,
                            steward_access_flag: this.addJob.steward_access_flag,
                            skill_id1: this.addJob.skill_id1 == "" ? null:this.addJob.skill_id1,
                            skill_id2: this.addJob.skill_id2 == "" ? null:this.addJob.skill_id2,
                            skill_id3: this.addJob.skill_id3 == "" ? null:this.addJob.skill_id3,
                            user_id: this.userID,
                            rate_id: this.addJob.rate_id
                        };
                        this.modalDataLoad = true;
                        service.post('job', fromData, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).then((res) => {
                            this.newJobId=res.data.result.id;
                            this.uploadImage();
                            this.$modal.hide("add-call");
                            this.$notify({
                                title: 'Success',
                                message: 'Job Added Successfully.',
                                type: 'success'
                            });
                            this.getSelectedTab();
                            this.$modal.hide("add-job");
                        }).catch((err) => {
                            console.log(err);
                        });
                        this.modalDataLoad = false;
                    } else {
                        this.validation_err = 1;
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill up all required fields.'
                        });
                    }
                });
            },

            getColor(color) {
                var value = color.substr(1);
                return value;
            },

            async editSingleJob() {
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        this.validateContent('edit_employer_requests', this.addJob.employer_requests);
                        this.validateContent('edit_content', this.addJob.comment);
                        if (this.hasValidationErrors()) {
                            this.$notify.error({
                                title: 'Error', 
                                message:'Please fix validation errors before saving.'}
                            ); 
                            return; // Stop the save process
                        }
                        this.editJobFormData = {
                            title: this.addJob.title,
                            employer_id: this.addJob.hiring_organization_id,
                            payroll_id: this.addJob.payroll_id,
                            payroll_source: this.payrollSourceFor(this.addJob.payroll_id),
                            employer_user_id: this.addJob.employer_contact,
                            link_color: this.getColor(this.addJob.link_color),
                            employee_id: this.addJob.employee_id,
                            created_by: this.addJob.created_by,
                            dispatched_by: this.addJob.dispatched_by,
                            start: this.addJob.start + " " + Date().slice(16, 24),
                            end: this.addJob.end + " " + Date().slice(16, 24),
                            venue_id: this.addJob.venue_id,
                            location_details: this.addJob.location_details,
                            employer_requests: this.addJob.employer_requests,
                            employer_requests_private: this.addJob.employer_requests_private,
                            employer_requests_signin: this.addJob.employer_requests_signin,
                            comment: this.addJob.comment,
                            comment_private: (this.addJob.comment_private) ? 1 : 0,
                            serial: '',
                            hts_flag:this.addJob.hts_flag,
							steward_access_flag:this.addJob.steward_access_flag,
                            skill_id1: this.addJob.skill_id1 == "" ? null:this.addJob.skill_id1,
                            skill_id2: this.addJob.skill_id2 == "" ? null:this.addJob.skill_id2,
                            skill_id3: this.addJob.skill_id3 == "" ? null:this.addJob.skill_id3,
                            updated_by: this.userID,
                            rate_id: this.addJob.rate_id
                        };
                        this.editJobAction = 'edit-job';
                        this.$modal.hide("edit-job");
                        this.$modal.show("edit-job-add-note");
                        this.editJobAddNote.note = 'Edit Job';
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            goToCalls(job) {
                this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: `/viewCalls/`+btoa(job.id)
                });
            },

            goToPhoneSheet(job) {
                this.$store.dispatch('setJob', job);
                this.$router.push({
                    path: `/phoneSheet/`+btoa(job.id)
                });
            },

            addJobModal() {
                this.modalDataLoad=true;
                service.get('getAllVenue', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employees) => {
                    this.employees = employees.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('employer/'+this.userClientID+'/getClientEmployerAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employers) => {
                    this.employers = employers.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                service.get('payroll/getPayrollDropdown', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((payrolls) => {
                    // getPayrollDropdown returns a flat array in `result` (client payrolls
                    // PLUS employers flagged is_payroll_company), not a paginator.
                    this.payrolls = payrolls.data.result || [];

                }).catch((err) => {
                    console.log(err);
                });

                this.addJob.employee_id = "";
                service.get('employee/getStewards', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.stewards = stewards.data.result;
                    if(this.stewards && this.stewards.length) {
                        let index = this.stewards.findIndex((item)=> item.user_id == this.userID);
                        if(index>=0) {
                            this.addJob.employee_id=this.stewards[index].id;
                        }else{
                            this.addJob.employee_id=""
                        }
                    }
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalDataLoad=false;

                });

                this.addJob.created_by = this.userID;
                this.addJob.dispatched_by = "";
                service.get('employee/getDispatchedByList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.dispatchedList = stewards.data.result;
                    this.modalDataLoad = false;
                    let index = this.dispatchedList.findIndex((item)=> item.user_id == this.userID);
                    if(index>=0){
                        this.addJob.dispatched_by = this.userID;
                    }
                    else{
                        this.addJob.dispatched_by = ""
                    }
                }).catch((err) => {
                    console.log(err);
                });

                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((skills) => {
                    this.positions = skills.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                this.addJob.title = '';
                this.addJob.hiring_organization_id = '';
                this.addJob.payroll_id= '';
                this.addJob.link_color = '#335479';
                this.addJob.start = '';
                this.addJob.end = '';
                this.addJob.venue_id = '';
                this.addJob.location_details = '';
                this.addJob.employer_requests = '';
                this.addJob.employer_requests_private = '';
                this.addJob.employer_requests_signin = '';
                this.addJob.comment = '';
                this.addJob.comment_private = '';
                this.addJob.skill_id1 = '';
                this.addJob.skill_id2 = '';
                this.addJob.skill_id3 = '';
                this.addJob.employer_contact = '';
                this.$modal.show("add-job");
                setTimeout(function (){
                    $('#event-name').focus();
                }, 500);
            },

            closeAddJob() {
                this.$modal.hide("add-job");
            },

            closeEditJob() {
                this.$modal.hide("edit-job");
            },

            async editJob(job) {
                this.modalDataLoad=true;
                this.$modal.show("edit-job");
                this.addJob.created_by = job.created_by;
                await service.get('getAllVenue', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;
                    this.addJob.venue_id = job.venue.id;
                    this.addLocationDetails(job.venue.id);
                }).catch((err) => {
                    console.log(err);
                });
                await service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employees) => {
                    this.employees = employees.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                await service.get('employer/'+this.userClientID+'/getClientEmployerAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async (employers) => {
                    this.employers = employers.data.result;
                    this.addJob.hiring_organization_id = job.employer_id;
                    await service.get('employer/'+this.addJob.hiring_organization_id+'/getAllEmployerUsersListing', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.employer_users=res.data.result.employer_users;
                        this.addJob.employer_contact=job.employer_user_id;
                    }).catch((err) => {
                        console.log(err);
                    })
                }).catch((err) => {
                    console.log(err);
                });

                service.get('payroll/getPayrollDropdown', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((payrolls) => {
                    // getPayrollDropdown returns a flat array in `result` (client payrolls
                    // PLUS employers flagged is_payroll_company), not a paginator.
                    this.payrolls = payrolls.data.result || [];
                }).catch((err) => {
                    console.log(err);
                });

                let self = this;
                this.addJob.employee_id="";
                service.get('employee/getStewards', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.stewards = stewards.data.result;
                    if(this.stewards&&this.stewards.length&&job.employee_id) {
                        let index = this.stewards.findIndex((item)=> item.id == job.employee_id);
                        if(index>=0) {
                            this.addJob.employee_id = job.employee_id;
                        }else {
                            this.addJob.employee_id = ""
                        }
                    } else if(this.stewards && this.stewards.length) {
                        for(var i=0; i<this.stewards.length; i++){
                            if(this.stewards[i].user_id == this.userID) {
                                self.addJob.employee_id=this.stewards[i].id;
                            }else{
                                self.addJob.employee_id="";
                            }
                        }
                    }
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                });

                this.addJob.dispatched_by = "";
                service.get('employee/getDispatchedByList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.dispatchedList = stewards.data.result;
                    if(job.dispatched_by&&job.dispatched_by!=""&&this.dispatchedList&&this.dispatchedList.length) {
                        let index = this.dispatchedList.findIndex((item)=> item.user_id == job.dispatched_by);
                        if(index>=0) {
                            this.addJob.dispatched_by = job.dispatched_by;
                        }else {
                            this.addJob.dispatched_by = ""
                        }
                    } else {
                        for(var i=0; i<this.dispatchedList.length; i++){
                            if(this.dispatchedList&&this.dispatchedList.length&&this.dispatchedList[i].user_id == this.userID) {
                                self.addJob.dispatched_by = self.userID;
                            }else{
                                this.addJob.dispatched_by = ""
                            }
                        }
                    }
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalDataLoad=false;
                });

                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((skills) => {
                    this.positions = skills.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                this.editJobId = job.id;
                this.addJob.title = job.title;
                // an employer-sourced payroll is stored in payroll_employer_id,
                // so preselect from whichever column carries it
                this.addJob.payroll_id = job.payroll_employer_id || job.payroll_id;
                this.addJob.link_color = "#" + job.link_color;
                let getStartDate = job.start.split(" ");
                let getEndDate = job.end.split(" ");
                this.addJob.start = getStartDate[0];
                this.addJob.end = getEndDate[0];
                this.addJob.employer_requests = job.employer_requests;
                this.addJob.employer_requests_private = job.employer_requests_private;
                this.addJob.employer_requests_signin = job.employer_requests_signin;
                this.addJob.comment = job.comment;
                this.addJob.comment_private = (job.comment_private == 1) ? true : false;
                this.addJob.hts_flag=job.hts_flag;
		        this.addJob.steward_access_flag=job.steward_access_flag;
                this.addJob.skill_id1 = job.skill_id1 == null ? "" : job.skill_id1;
                this.addJob.skill_id2 = job.skill_id2 == null ? "" : job.skill_id2;
                this.addJob.skill_id3 = job.skill_id3 == null ? "" : job.skill_id3;
                this.addJob.rate_id = job.rate_id ? job.rate_id : '';
            },

            cloneJob(job) {
                this.cloneJobId = job.id;
                this.cloneJobTitle= job.title;
                this.$modal.show("clone-job");
            },

            saveCloneJob() {
                if (!this.cloneDate) {
                    this.$notify({
                        title: 'Validation',
                        message: 'Please select a clone date.',
                        type: 'warning'
                    });
                    return;
                }
                this.editJobAddNote.note='Clone Job';
                this.editJobAction='clone-job';
                this.$modal.hide('clone-job');
                this.$modal.show('edit-job-add-note');
            },

            closeCloneJob() {
                this.$modal.hide("clone-job");
            },

            jobDetails(job) {
                this.$store.dispatch('setJob', job);
                this.$router.push({
                    path: `/jobDetails/`+btoa(job.id)
                });
            },

            changeJobIdMorph(id) {
                return btoa(id);
            },

            addFileForAddNewJob(e, index) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true;
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },

            uploadImage() {
                for (var i = 0; i < this.new_files.length; i++) {

                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false && this.new_files[i].selected==true) {
                        this.uploadService(this.new_files[i]).then((path) => {
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
            },

            uploadService(img) {
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.uploaded = true;

                            let activityData = {
                                uploader_id: this.userID,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.newJobId,
                                created_by: this.employeeId,
                                attachable_type: 'job',
                                filename: img.name,
                                description: 'Job Document',
                                label: img.label,
                                path: img.path,
                                activity: JSON.stringify(activityData)
                            }
                            service.post('attachment', fromData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID
                            })
                            .then((res) => {

                            }).catch((err) => {
                                 console.log(err);
                            });

                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;
            },
            
            cloneInputfile() {
                this.new_files.push({
                    'name': 'No file chosen',
                    'selected': false,
                });
            },

            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },

            removeFile(key) {
                this.new_files.splice(key, 1);
            },

            snippet(value) {
                if (value.length > 15)
                    return value.slice(0, 15) + '  ...';
                else
                    return value;
            },

            publishedJob(job) {
                this.publishedJobId = job.id;
                this.publishedJobStatus = job.status.name;
                this.editJobAction = 'publish';
                this.$modal.show("edit-job-add-note");
                this.editJobAddNote.note=this.publishedJobStatus=='Published'?'Publish':'Unpublish';
            },

            confirmDelete(){
                if(this.verifyedJobName.trim().toLowerCase() != this.selectedJob.title.trim().toLowerCase()){
                    this.$notify({
                        type: 'error',
                        title:'Error',
                        message: 'Job name mismatch. Please enter the valid job name.'
                    });
                    return;
                }
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                }
                let isNotify = this.deleteWithNotify?1:0;
                activityID = JSON.stringify(activityID);
                service.post('job/' + this.selectedJobId + '/softDeleteJobs', {
                    'activity': activityID,
                    'notify': isNotify,

                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userid': this.userID,
                }).then((res) => {
                    this.deleteWithNotify = false;
                    this.centerDialogVisible = false;
                    this.dialogFormVisible = false;
                    this.verifyedJobName = "";
                    this.$Progress.finish();
                    this.$message({
                        type: 'success',
                        message: 'Delete Job completed successfully'
                    });
                    this.getSelectedTab();
                }).catch((err) => {
                    console.log(err);
                });
            },

            deleteJob(jod) {
                this.selectedJobId = jod.id;
                this.centerDialogVisible = true;
                this.selectedJob = jod;
                this.verifyedJobName = "";
                this.dialogFormVisible = false;
            },

            restoreJob(job){
                this.selectedJob = job;
                this.selectedJobId = job.id;
                this.restorerDialogVisible = true;
            },

            preview(){
                this.restorerDialogVisible = false;
                this.$router.push({
                    path: `/review-job/`+ btoa(this.selectedJobId)
                });
            },

            confirmRestore(type){
                this.restorerDialogVisible = false;
                service.post('job/' + this.selectedJobId + '/restoreJob', {
                    'restore_option': type,
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userid': this.userID,
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: 'Delete Job completed successfully'
                    });
                    this.getSelectedTab();

                }).catch((err) => {
                    console.log(err);
                });
            },

            checkCalls(job) {
                if(job.calls_count) {
                    return false;
                }
                return true;
            },

            goToAddCalls(job) {
                this.$router.push({
                    path: `/addCall/`+btoa(job.id)
                });
            },

            filterSliderArea() {
                $('.o-filterslider-container').removeClass('is-active');
                $('.o-filtersilder-area').delay(100).fadeOut(300);
            },

            filterSliderContainer(e) {
                e.stopPropagation();
            },

            filterLink() {
                $('.o-filtersilder-area').fadeIn(200, function(e) {
                    $('.o-filterslider-container').addClass('is-active');
                });
                this.jobFilter = {
                    startDate: new Date(),
                    direction: 'desc',
                    resultPerPage: '25',
                    conditionType: 'employer',
                    conditionValue: '',
                };
                service.get('getAllVenue', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;
                }).catch((err) => {
                    console.log(err);
                });

                service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employees) => {
                    this.employees = employees.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                service.get('employer/'+this.userClientID+'/getClientEmployerAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((employers) => {
                    this.employers = employers.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                service.get('payroll/getPayrollDropdown', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((payrolls) => {
                    // getPayrollDropdown returns a flat array in `result` (client payrolls
                    // PLUS employers flagged is_payroll_company), not a paginator.
                    this.payrolls = payrolls.data.result || [];

                }).catch((err) => {
                    console.log(err);
                });

                service.get('employee/getStewards', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.stewards = stewards.data.result;
                }).catch((err) => {
                    console.log(err);
                });

                service.get('employee/getDispatchedByList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.dispatchedList = stewards.data.result;
                }).catch((err) => {
                    console.log(err);
                });
                //console.log("jobFilter open");
            },

            filterClose() {
                $('.o-filterslider-container').removeClass('is-active');
                $('.o-filtersilder-area').delay(100).fadeOut(300);
            },

            clearFilter() {
                this.jobFilter = {
                    startDate: '',
                    direction: 'desc',
                    resultPerPage: '25',
                    conditionType: 'employer',
                    conditionValue: '',
                };
            },

            applyFilter() {
                // Inherit date range from the active tab if no explicit start date in filter
                let filterStart = '';
                let filterOrder = this.jobFilter.direction;

                if (this.jobFilter.startDate != '') {
                    // User explicitly set a date in the filter slider
                    filterStart = moment(this.jobFilter.startDate).format('YYYY-MM-DD HH:mm:ss');
                } else {
                    // Inherit from current tab context
                    const activeChild = this.preSelectedTab.child;
                    if (activeChild == 'month') {
                        // Month view — use the displayed month's last day as start, desc to show all
                        const ref = this.monthSort || new Date();
                        filterStart = moment(ref).endOf('month').format('YYYY-MM-DD HH:mm:ss');
                        filterOrder = 'desc';
                    } else if (activeChild == 'today') {
                        filterStart = moment().format('YYYY-MM-DD HH:mm:ss');
                    } else if (activeChild == 'tomorrow') {
                        filterStart = moment().add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
                    } else if (activeChild == 'day') {
                        // Next 45 days — ascending from today
                        filterStart = moment().format('YYYY-MM-DD HH:mm:ss');
                        filterOrder = 'asc';
                    } else if (activeChild == 'incomplete') {
                        // Incomplete — descending from today
                        filterStart = moment().format('YYYY-MM-DD HH:mm:ss');
                        filterOrder = 'desc';
                    }
                }

                let fromData = {
                    employer_id: (this.jobFilter.conditionType == "employer") ? this.jobFilter.conditionValue : '',
                    venue_id: (this.jobFilter.conditionType == "venue") ? this.jobFilter.conditionValue : '',
                    payroll_id: (this.jobFilter.conditionType == "payroll") ? this.jobFilter.conditionValue : '',
                    steward_id: (this.jobFilter.conditionType == "steward") ? this.jobFilter.conditionValue : '',
                    created_by: (this.jobFilter.conditionType == "createdBy") ? this.jobFilter.conditionValue : '',
                    order: filterOrder,
                    start: filterStart,
                    paginate: this.jobFilter.resultPerPage,
                };
                this.storeMore = [];
                this.afterAPI = false;
                this.loading = true;
                service.post('job/filter', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'sort-type': this.sortType
                    })
                    .then((res) => {
                        this.preSelectedTab.parent = 'Alljob'
                        this.preSelectedTab.child = 'filter';
                        this.loading = false;
                        this.jobList = res.data.result.data;
                        this.next_page = res.data.result.next_page_url;
                        this.current_page = res.data.result.current_page;
                        this.afterAPI = true;
                        if (this.next_page != null) {
                            service.post('job/filter?page='+(this.current_page+1), fromData, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'sort-type': this.sortType
                                })
                                .then((res) => {
                                    this.storeMore = res.data.result.data;
                                    this.next_page = res.data.result.next_page_url;
                                    this.current_page = res.data.result.current_page;

                                }).catch((err) => {
                                    console.log(err);
                                })
                        }
                        this.filterClose();
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            getFilterPagination(){
                let fromData = {
                    employer_id: (this.jobFilter.conditionType == "employer") ? this.jobFilter.conditionValue : '',
                    venue_id: (this.jobFilter.conditionType == "venue") ? this.jobFilter.conditionValue : '',
                    payroll_id: (this.jobFilter.conditionType == "payroll") ? this.jobFilter.conditionValue : '',
                    steward_id: (this.jobFilter.conditionType == "steward") ? this.jobFilter.conditionValue : '',
                    created_by: (this.jobFilter.conditionType == "createdBy") ? this.jobFilter.conditionValue : '',
                    order: this.jobFilter.direction,
                    start: (this.jobFilter.startDate != '') ? moment(this.jobFilter.startDate).format('YYYY-MM-DD HH:mm:ss')  : '',
                    paginate: this.jobFilter.resultPerPage,
                };
                if (this.next_page != null) {
                    service.post('job/filter?page='+(this.current_page+1), fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'sort-type': this.sortType
                    }).then((res) => {
                        this.storeMore = res.data.result.data;
                        this.next_page = res.data.result.next_page_url;
                        this.current_page = res.data.result.current_page;
                    }).catch((err) => {
                        console.log(err);
                    })
                }
            },

            hiddenTextfield(event, id) {
                $('#' + id).siblings('.js-hidden-textfield').removeClass('is-active');
                $('#' + id).addClass('is-active');
            },

            displayEmployerContact(job){
                let employerContact = '';
                if(job.employer&&job.employer.employer_users&&job.employer.employer_users.length){
                    job.employer.employer_users.forEach((user) => {
                        if(user.user.id == job.employer_user_id) {
                            employerContact = ', ' + user.user.first_name + ' ' + user.user.last_name;
                        }
                    })
                }
                return employerContact;
            },

            openEditJobAddNoteDialog() {
                this.$modal.show("edit-job-add-note");
                this.editJobAddNote.note = '';
            },

            closeEditJobNote() {
                this.$modal.hide("edit-job-add-note");
            },

            editJobAddNewNote() {
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                }
                activityID = JSON.stringify(activityID);
                var jobNote = {
                    noteable_id: this.cloneJobId,
                    noteable_type: 'job',
                    activity: activityID,
                    content: this.editJobAddNote.note,
                };

                let type = this.editJobAction;
                switch(type){
                    case 'edit-job':
                        this.editJobRequest(jobNote);
                        break;
                    case 'deny-steward-access':
                        this.switchStewardAccess(jobNote);
                        break;
                    case 'comments':
                        this.updateCalendarCommentEmployerRequest(jobNote);
                        break;

                    case 'clone-job':
                        this.saveCloneJobRequest(jobNote);
                        break;
                    case 'publish':
                        jobNote.noteable_id = this.publishedJobId;
                        this.switchPublishAddNote(jobNote);
                        break;
                    default:
                        console.log("Default Add Note");
                }
            },

            saveCloneJobRequest(jobNote) {
                this.modalLoading = true;
                this.$forceUpdate();
                jobNote.client_id = this.userClientID;
                jobNote.start = this.cloneDate + " " + Date().slice(16, 24);
                jobNote.assign = (this.cloneAssignment) ? 1 : 0;
                jobNote.user_id = this.userID;
                service.post('job/' + this.cloneJobId + '/clone', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: res.data.result,
                        type: 'success'
                    });
                    this.modalLoading = false;
                    this.changeTab(this.preSelectedTab.parent, this.preSelectedTab.child, true);
                    this.$modal.hide("edit-job-add-note");
                }).catch((err) => {
                    this.modalLoading = false;
                    this.$modal.hide("edit-job-add-note");
                    this.$notify({
                        title: 'Error',
                        message: err.response && err.response.data && err.response.data.result
                            ? err.response.data.result
                            : 'Failed to clone job. Please try again.',
                        type: 'error'
                    });
                    console.log(err);
                });
            },

            async editJobRequest(jobNote) {
                this.editJobFormData.noteable_id = jobNote.noteable_id;
                this.editJobFormData.noteable_type = jobNote.noteable_type;
                this.editJobFormData.activity = jobNote.activity;
                this.editJobFormData.content = jobNote.content;
                this.modalLoading = true;
                await service.put('job/' + this.editJobId, this.editJobFormData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userid': this.userID
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Job Updated Successfully.',
                        type: 'success'
                    });
                    this.$modal.hide("edit-job-add-note");
                    this.editJobAction == '';
                    this.editJobFormData = null;
                    this.getSelectedTab();
                }).catch((err) => {
                    console.log(err);
                });
                this.modalLoading = false;
            },

            switchPublishAddNote(jobNote) {
                this.$Progress.start();
                jobNote.hiring_organization = '';
                jobNote.venue = '';
                if (this.publishedJobStatus == "Published") {
                    service.put('job/' + this.publishedJobId + '/publish', jobNote, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$modal.hide('edit-job-add-note');
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        })
                        this.$Progress.finish();
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    service.put('job/' + this.publishedJobId + '/unpublish', jobNote, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$modal.hide('edit-job-add-note');
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        })
                        this.$Progress.finish();
                    }).catch((err) => {
                        console.log(err);
                    });
                }

            },

            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    if (this.containsInvalidContent(plainText)) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            message: 'Content contains invalid text. Please review and correct.'
                        });
                    }
                }
            },
    
            getPlainText(html) {
                // Remove HTML tags and get plain text
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent || div.innerText || '';
            },
    
            containsInvalidContent(text) {                                
                // Example 1: Check for script tags or malicious content
                const scriptPattern = /<script|javascript:|onerror=|onclick=/i;
                
                // Example 2: Check for excessive special characters
                const excessiveSpecialChars = /[.?!,#$^&*()@%|"':;<>]{3,}/;
                
                // Example 3: Check for spam-like patterns (multiple repeated characters)
                const spamPattern = /(.)\1{3,}/;
                
                // Example 4: Check for invalid URLs or suspicious links
                const suspiciousUrl = /bit\.ly|tinyurl|goo\.gl/i;
                
                // Return true if any invalid pattern is found
                return scriptPattern.test(text) || 
                excessiveSpecialChars.test(text) || 
                spamPattern.test(text) ||
                suspiciousUrl.test(text);
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
            

        mounted() {
            this.$nextTick(() => {
                this.domReady = true
            });

            setTimeout(()=>{
                var sidenavWidth = $(".mainSidenav").width();
                var windowWidth = $(window).width();
                $(".o-header").css('width', windowWidth - sidenavWidth);
                var con = $('.o-sidenav.mainSidenav').hasClass('open');
                var wrap = $('.table_header_wrapper.sticky_header');
                var c = 'animate_header';
                var temp = con ? wrap.addClass(c) : wrap.removeClass(c);
                if(con){
                  var myWidth=windowWidth-260;
                  $('.with-adjust-on-open-sidenav').css('width', myWidth);
                }else{
                  var myWidth=windowWidth-100;
                  $('.with-adjust-on-open-sidenav').css('width', myWidth);
                }
            }, 1000);
            var windowWidth = $(window).width();
            if (windowWidth > 1366) {
                $('.mainSidenav').css('width', '220px').addClass('open');
                $('.wrapper').css('margin-left', '220px');
                $('.js-sidebarTrigger').children().removeClass('fa-bars').addClass('fa-arrows-alt');
                $(".o-header").css('width', this.windowWidth - 220);
                $('.js-sidebarTrigger').css('left', '230px');
            }else{
                $('.wrapper').css('margin-left', '60px');
            }
        }
    }

</script>
<style scoped>

    .mb-1 {
        margin-bottom: 3px;
    }

    #page {
        visibility: visible !important;
    }

    .mt-10 {
        margin-top:10px;
    }
    .mb-5 {
        margin-bottom:5px;
    }
    .font-bl {
        color: #000000;
    }
    .o-left-padding-10 {
        padding-left: 10px;
    }
    a.fl-right {
        margin-top: 5px;
        margin-bottom: 0;
        padding: 0;
        float: right;
    }
    .el-dialog__body{
        padding: 0px 20px !important;
    }
    .ml-10{
        margin-left: 10px;
    }
    .modal-body {
        margin: 0px 15px;
    }

    .err-msg {
        margin: 2px;
        color: red
    }

    .status_message {
        margin: 15px 220px
    }

    .c-common-btn {
        font-size: 14px!important;
        cursor: pointer;
    }

    a {
        cursor: pointer;
    }
    sup{
        color: red;
    }
    .new-call-phone-btn{
        background-color: #ffffff;
        padding: 5px;
        border-radius: 6px;
        font-weight: 600;
        font-size: 16px;
        border: 1px solid;
    }
    .new-admin-event-head{
        padding: 0px 10px;
        border-radius: 16px;
        display: inline-block !important;
        color: #fff !important;
    }
    .new-admin-event-head-orange{
        background-color: #FB8B03;
    }
    .new-admin-event-head-green{
        background-color: #0c8a2d;
    }
    .new-admin-event-head-purple{
        background-color: #800080;
    }
    .new-admin-event-head-teal{
        background-color: #008080;
    }
    .new-o-accordion-title a {
        font-size: 16px;
        font-weight: 500;
        line-height: 25px;
        width: 100%;

    }
    .new-o-accordion-title{
        padding-right: 5px;
    }
    .new-o-accordion-heading{
        padding: 10px 0px 10px 5px;
    }
    .o-job-accordio-header li {
        padding-right: 5px;
        padding-left: 5px;
    }
    .o-issue-counter
    {
        width: 69px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: unset;
    }
    .sticky_header {
        position: fixed;
        right: 0;
        left: 0;
        min-width: 100%;
        padding: 10px 30px 0px 90px;
        z-index: 1;
    }
    .min-with-select-box{
        min-width: 160px;
    }
    .margin-bottom-2px{
        margin-bottom: 2px;
    }
    .employer-header-font-min{
        font-size: 13px !important;
        line-height: 24px !important;
    }
    .o-clock-font{
        font-size: 21px;
    }
    .o-icon-right-2nd-row{
        position: absolute;
        right: 10px;
        top: 29px;
    }

    .spinner {
  margin: 20px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: #409EFF; /* Element UI primary color */
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out both;
  animation: bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2, .spinner .bounce3 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}



</style>
